import { Box, Switch, Typography, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import DigitalColorMeter from '@/components/sidebar/DigitalColorMeter'
import Gallery from '@/components/sidebar/Gallery'
import { useAppSelector } from '@/store'
import type { RootState } from '@/store'
import type { LABColor } from '@/store/appSlice'
import { toggleGrayscale } from '@/store/shadeGuide'
import { DEHAZE_INCLUDED_PATHS } from '@/utils/constants'

import Dehazing from './Dehazing'

const Sidebar = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const location = useLocation()
  const labColor = useSelector<RootState, LABColor>(
    (store) => store.app.selectedColor,
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)
  const isGrayscaleMap = useAppSelector(
    (state) => state.shadeGuide.isGrayscale,
  ) as Record<string, boolean>
  const imageId = canvasImage?.id
  const currentImageGrayscale = imageId ? isGrayscaleMap?.[imageId] : false

  const isShadeGuidePath = location.pathname.includes('/shade-guide-ai')

  const handleGrayToggle = () => {
    if (imageId) {
      dispatch(toggleGrayscale({ imageId: String(imageId) }))
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      flexGrow="1"
      overflow="auto"
      component="aside"
    >
      <Gallery />
      <DigitalColorMeter labColor={labColor} />
      {isShadeGuidePath && (
        <Box
          sx={{
            px: '8px',
            pt: '24px',
            pb: '48px',
            display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${theme.palette.text.primary}50`,
          }}
        >
          <Switch
            checked={!!currentImageGrayscale}
            onChange={handleGrayToggle}
            color="primary"
          />
          <Typography
            variant="body1"
            sx={{ color: 'text.primary', fontSize: '20px' }}
          >
            Grayscale Mode
          </Typography>
        </Box>
      )}
      {DEHAZE_INCLUDED_PATHS.includes(location?.pathname || '') && <Dehazing />}
    </Box>
  )
}

export default Sidebar
